import { Injectable } from '@angular/core';
import { ApiHttp } from 'app/providers';
import { MessageService } from 'primeng/api';
import { GetTransferOrderDetailsRequest } from './models/get-transfer-order-details-request.model';
import { GetTransferOrderDetailsResponse } from './models/get-transfer-order-details-response.model';
import { RegenerateQrCodeRequest } from './models/regenerate-transfer-order-request';
import { BaseResponse } from 'XpressTransfer/app/transfer/components/transfer/shared/interfaces/response/base-response.interface';

@Injectable({ providedIn: 'root' })
export class XpassAdminService {
  private apiRoot = 'api/XpressTransferAdmin';

  constructor(private apiHttp: ApiHttp) {}

  public getTransferOrderDetails(
    request: GetTransferOrderDetailsRequest,
    messageService: MessageService
  ): Promise<GetTransferOrderDetailsResponse> {
    return this.apiHttp.post(
      `${this.apiRoot}/GetTransferOrderDetails`,
      request,
      messageService
    );
  }

  public regenerateTransferOrder(
    request: RegenerateQrCodeRequest,
    messageService: MessageService
  ): Promise<BaseResponse> {
    return this.apiHttp.post(
      `${this.apiRoot}/RegenerateQrCode`,
      request,
      messageService
    );
  }
}
